import { useEffect, useState, useRef } from 'react'
import gql from 'graphql-tag'
import { useApplicationContext } from '../../context'

const useGraphNotificationSubscriptionHook = () => {
  const closeCurrentOperation = useRef(() => {})
  const [notification, setNotification] = useState()
  const { user, logger, graphWebsocket } = useApplicationContext()
  useEffect(() => {
    if (user.logged_in) {
      graphWebsocket
        .subscribe({
          operationOptions: {
            query: gql`
              subscription toolkitAdc_subscribeToUserNotifications {
                notificationSent {
                  content
                  read
                  displayed
                  message_id
                  notification_intent_code
                  created_date
                }
              }
            `,
          },
          onData: data => {
            setNotification(data?.notificationSent)
          },
          onError: error => {
            logger.warn(error)
          },
        })
        .then(graphSubscriber => {
          closeCurrentOperation.current = graphSubscriber.unsubscribe
          return true
        })
        .catch(err => logger.warn(err))

      return () => closeCurrentOperation.current?.()
    }
  }, [user.logged_in, graphWebsocket, logger])

  return {
    notification,
  }
}

export default useGraphNotificationSubscriptionHook
